var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFooterAirplane = function SvgIcFooterAirplane(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#585A64",
    d: "M2.319 1.603a.5.5 0 0 0-.618.627L3.323 7.5H9a.5.5 0 0 1 0 1H3.323L1.7 13.77a.5.5 0 0 0 .618.627 40.3 40.3 0 0 0 12.296-5.991.5.5 0 0 0 0-.812A40.3 40.3 0 0 0 2.32 1.603"
  })));
};
export default SvgIcFooterAirplane;